module.exports = __webpack_public_path__ + "static/media/app_game.c99373cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/work/assets/app_game.png
// module id = 378
// module chunks = 0